import home from '../page/home.vue'
import index from '../page/index.vue'
import lrLayout from '../page/lrLayout.vue'
import purchaseList from '../page/purchaseList.vue'
import purchaseContent from '../page/purchaseContent.vue'
import tenderingList from '../page/tenderingList.vue'
import tenderingContent from '../page/tenderingContent.vue'
import policyList from '../page/policyList.vue'
import policyContent from '../page/policyContent.vue'
import feeList from '../page/feeList.vue'
import feeContent from '../page/feeContent.vue'
import cpyResultList from '../page/cpyResultList.vue'
import cpyResultContent from '../page/cpyResultContent.vue'
import cpyIntroduction from '../page/cpyIntroduction.vue'


export default [
    {
        path: '/home',
        component: home,
        children: [
            {
                path: '/index',
                component: index,
            },
            {
                path: '/lrLayout',
                component: lrLayout,
                children:[

                ]
            },
            {
                path: '/purchaseList',
                component: purchaseList,
            },
            {
                path: '/purchaseContent',
                component: purchaseContent,
            },
            {
                path: '/tenderingList',
                component: tenderingList,
            },
            {
                path: '/tenderingContent',
                component: tenderingContent,
            },
            {
                path: '/policyList',
                component: policyList,
            },
            {
                path: '/policyContent',
                component: policyContent,
            },
            {
                path: '/feeList',
                component: feeList,
            },
            {
                path: '/feeContent',
                component: feeContent,
            },
            {
                path: '/cpyResultList',
                component: cpyResultList,
            },
            {
                path: '/cpyResultContent',
                component: cpyResultContent,
            },
            {
                path: '/cpyIntroduction',
                component: cpyIntroduction,
            },

        ]
    },
    { path: '*', redirect: '/index' }
]



// WEBPACK FOOTER //
// ./src/configs/router.js